export default __webpack_public_path__ + "static/media/microsoft.c945ca84.png";